<template>
  <div class="vod-player">
    <div class="info-bar back-purple-dark">
      <h2>{{awayTeamName}} VS {{homeTeamName}} ({{gamePlace}})</h2>
    </div>
    <div class="video-wrap" v-adjust-height>
      <div class="left-contents">
        <div v-if="contentId !== ''" id="container" ref="container" class="video-container"></div>
        <!--하이라이트 없는 경우-->
        <div v-else class="highlight-wrap">
          <div>
            <img src="../../../assets/images/kbo/icon-empty.png" alt="하이라이트 준비 중 아이콘">
            <h3>하이라이트 준비 중</h3>
            <p>본 경기 하이라이트 영상은 업데이트 예정입니다.<br>업데이트 후 시청해주세요. </p>
          </div>
        </div>
        <!--/하이라이트 없는 경우-->
      </div>
      <div class="right-contents">
        <div class="tab-area">
          <h3 class="tab-title">문자 중계</h3>
          <div class="tab-panels">
            <div id="tabPanel01" class='tab selected'>
              <text-relay :game-id="gameId"></text-relay>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TextRelay from '@/components/player/baseball/TextRelay'
  import { destroyPlayer, detachPlayerEvents, getUserInfo } from '@/common/utils/common'
  import { playerDelegate } from '@/common/utils/scalable.player'
  import _ from 'lodash'
  import { adjustHeight } from '@/common/resources/directives'
  export default {
    name: 'BaseballResultPlayer',
    props: {
      gameId: {
        type: String
      },
      vsScoreResult: {
        type: Object
      },
      contentId: {
        type: String
      }
    },
    directives: {
      adjustHeight
    },
    components: {
      TextRelay
    },
    computed: {
      homeTeamName () {
        return _.get(this.vsScoreResult, 'homeTeamName', '')
      },
      awayTeamName () {
        return _.get(this.vsScoreResult, 'awayTeamName', '')
      },
      gamePlace () {
        return _.get(this.vsScoreResult, 'gamePlace', '')
      }
    },
    methods: {
      playerInit () {
        if (this.contentId !== '') {
          // destroyPlayer()
          getUserInfo().then((userInfo) => {
            window.playerInstance.setUserInfo(userInfo)
            window.playerInstance.load('baseballhighlight', this.contentId)
          })
        }
      }
    },
    mounted () {
      if (this.contentId !== '') {
        playerDelegate(this, this.$refs.container)
      }
    },
    beforeDestroy () {
      detachPlayerEvents()
      destroyPlayer()
    }
  }
</script>
<style scoped>
  .highlight-wrap{
    position: relative;
    width: 100%;
    height: 100%;
    background-color: #000;
  }

  .highlight-wrap > div{
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    text-align: center;
  }

  .highlight-wrap img{
    width: 94px;
  }

  .highlight-wrap h3{
    margin: 30px 0 20px;
    font-size: 36px;
    line-height: 54px;
    color: #fff;
    font-weight: 400;
  }

  .highlight-wrap p{
    font-size: 16px;
    line-height: 24px;
    color: #a5a5a5;
  }

  .tab-title{
    padding: 0 20px;
    border-bottom: 1px #2f2f2f solid;
    font-size: 18px;
    line-height: 66px;
    color: #fff;
    font-weight: 400;
  }

  /* 확인 필요 소스 */
  .tab,
  .tab > div{
    height: 100%;
  }
</style>
